/**
 * Der Knopf — das Bauteil, an dem die Feldtauglichkeit zuerst scheitert.
 *
 * `07` §7.14 nennt drei Anforderungen, die alle hier zusammenlaufen: große
 * Touchziele, Bedienung mit einer Hand, robuste Bedienung mit Handschuhen. Ein
 * Monteur tippt nicht mit der Präzision eines Bürostuhls; was auf dem
 * Entwicklerbildschirm elegant wirkt, ist auf der Baustelle ein Fehlklick.
 *
 * Die Größen kommen deshalb aus den Token und nicht aus dem Stil: `beruehrung`
 * für den Alltag, `beruehrungGross` für die Hauptaktionen eines Einsatzes —
 * „Einsatz beginnen", „Abschluss senden". Wer sie hier überschreiben wollte,
 * müsste es sichtbar tun.
 *
 * **`type` ist Pflicht und hat keine Vorgabe.** Ein `<button>` ohne `type` ist
 * in einem Formular ein Absendeknopf, auch wenn er „Abbrechen" heißt — der
 * Fehler fällt erst auf, wenn jemand mit der Eingabetaste arbeitet, und dann
 * ist das Formular abgeschickt.
 */

import type { ButtonHTMLAttributes, ReactNode } from "react";

export const KNOPFARTEN = ["haupt", "neben", "still"] as const;
export type Knopfart = (typeof KNOPFARTEN)[number];

export interface KnopfEigenschaften
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "className" | "type"> {
  readonly art?: Knopfart;
  /** `true` für die Hauptaktion eines Einsatzes — größere Trefferfläche. */
  readonly gross?: boolean;
  readonly type: "button" | "submit" | "reset";
  readonly children: ReactNode;
}

export function Knopf({
  art = "neben",
  gross = false,
  children,
  ...rest
}: KnopfEigenschaften) {
  const klassen = [
    "knopf",
    `knopf--${art}`,
    gross ? "knopf--gross" : "",
  ].filter(Boolean).join(" ");

  return (
    <button className={klassen} {...rest}>
      {children}
    </button>
  );
}
